import PropTypes from 'prop-types'

/**
 * Shared stats/counts footer for the knowledge-graph surfaces, so student, tutor, and admin show
 * their applicable numbers in one consistent style. Each surface passes `groups` — an array of
 * groups, each an array of `{ label, value, icon?, color? }` items — rendered as a wrapped row with
 * a divider between groups (e.g. admin: [nodes, edges, questions] | [Math, R&W] | [E, M, H]).
 */
export default function KnowledgeGraphStatsFooter({ groups = [] }) {
  const visible = groups.filter((g) => g && g.length > 0)
  if (visible.length === 0) return null

  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-600 dark:text-gray-400">
      {visible.map((group, gi) => (
        <div key={gi} className="flex flex-wrap items-center gap-x-4 gap-y-2">
          {gi > 0 && <span className="hidden sm:inline text-gray-300 dark:text-gray-600">|</span>}
          {group.map(({ label, value, icon: Icon, color }, i) => (
            <span key={i} className={`flex items-center gap-1 ${color || ''}`}>
              {Icon && <Icon className="w-4 h-4" />}
              <span className="font-medium">{value}</span>
              {label && <span>{label}</span>}
            </span>
          ))}
        </div>
      ))}
    </div>
  )
}

KnowledgeGraphStatsFooter.propTypes = {
  groups: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.node,
        value: PropTypes.node,
        icon: PropTypes.elementType,
        color: PropTypes.string
      })
    )
  )
}
